import action1 from './actions1.client';
import componentActions from './actions2.client';

const actions = {
  ...action1,
  ...componentActions
};

export default actions;
